const WhatsappButton = () => {
    return (
      <div className="fixed bottom-[55px] right-6 z-50 group">
        <div className="absolute bottom-16 right-1/2 translate-x-1/2 bg-white text-gray-800 text-xs px-3 py-1 rounded shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 before:content-[''] before:absolute before:top-full before:left-1/2 before:-translate-x-1/2 before:border-8 before:border-transparent before:border-t-white">
          ¿Hablamos por WhatsApp?
        </div>
  
        {/* Botón con animaciones */}
        <a
          href="https://wa.link/zid2kt"
          target="_blank"
          rel="noopener noreferrer"
          className="relative bg-gradient-to-br from-green-400 to-green-600 p-4 rounded-full text-white shadow-lg shadow-green-500/30 transition-transform duration-300 hover:rotate-6 hover:scale-110"
        >
          {/* Pulso decorativo */}
          <span className="absolute inset-0 rounded-full animate-ping bg-green-500 opacity-30" />
  
          {/* Icono */}
          <i className="bi bi-whatsapp relative z-10 text-2xl" />
        </a>
      </div>
    );
  };
  
  export default WhatsappButton;
  